/**
 * Author: Stefan Haack (https://shaack.com)
 */
import {Stopwatch} from "../../../lib/cm-web-modules/stopwatch/Stopwatch.js"
import {get} from "svelte/store"
import {sessionData} from "../../stores.js"
import {consoleMessageTopics} from "../../../lib/chess-console/ChessConsole.js"

export class Clock {

    constructor(chessConsole) {
        this.chessConsole = chessConsole
        this.stopwatchWhite = new Stopwatch({
            onTimeChanged: () => {
                this.redraw()
            }
        })
        this.stopwatchBlack = new Stopwatch({
            onTimeChanged: () => {
                this.redraw()
            }
        })
        this.tenToggle = false
        this.chessConsole.app.state.addObserver(() => {
            this.stopwatchWhite.stop()
            this.stopwatchBlack.stop()
            this.stopwatchWhite.reset()
            this.stopwatchBlack.reset()
            if (chessConsole.app.state.gameState._uciMoves.length > 1 && this.chessConsole.isGameRunning()) {
                if (chessConsole.isWhiteMove()) {
                    this.stopwatchWhite.start()
                } else {
                    this.stopwatchBlack.start()
                }
            }
            this.redraw()
        }, ["gameState"])
        this.redraw()
        this.chessConsole.messageBroker.subscribe(consoleMessageTopics.initGame, () => {
            this.redraw()
        })
    }

    redraw() {
        const serverClockWhite = parseFloat(this.chessConsole.app.state.gameState._clock.white) - this.stopwatchWhite.secondsExpired() + 0.9999
        const serverClockBlack = parseFloat(this.chessConsole.app.state.gameState._clock.black) - this.stopwatchBlack.secondsExpired() + 0.9999
        this.tenSecondTrigger(serverClockWhite, serverClockBlack)
        let timeWhite = this.millisecondsToTime(Math.max(0, serverClockWhite * 1000))
        let timeBlack = this.millisecondsToTime(Math.max(0, serverClockBlack * 1000))
        if (this.chessConsole.isGameRunning()) {
            if (this.chessConsole.isWhiteMove()) {
                timeWhite = timeWhite.replace(":", "<span class='active'>:</span>")
            } else {
                timeBlack = timeBlack.replace(":", "<span class='active'>:</span>")
            }
        }
        const sessionDataValue = get(sessionData)
        let updated = false
        if (this.chessConsole.isPlayerWhite()) {
            if (timeWhite !== sessionDataValue.playerClock || timeBlack !== sessionDataValue.opponentClock) {
                sessionDataValue.playerClock = timeWhite
                sessionDataValue.opponentClock = timeBlack
                updated = true
            }
        } else {
            if (timeBlack !== sessionDataValue.playerClock || timeWhite !== sessionDataValue.opponentClock) {
                sessionDataValue.playerClock = timeBlack
                sessionDataValue.opponentClock = timeWhite
                updated = true
            }
        }
        if (updated) {
            sessionData.set(sessionDataValue)
        }
    }

    millisecondsToTime(ms) {
        const seconds = Math.floor((ms / 1000) % 60)
        const minutes = Math.floor((ms / (60 * 1000)) % 60)
        return minutes + ":" + (seconds < 10 && seconds >= 0 ? "0" : "") + seconds //  + "." + Math.floor(milliseconds / 100)
    }

    tenSecondTrigger(serverClockWhite, serverClockBlack) {
        if (!this.tenToggle) {
            if (this.chessConsole.isPlayerWhite() && serverClockWhite < 11 && serverClockWhite > 0) {
                this.chessConsole.messageBroker.publish(consoleMessageTopics.tenSecondsLeft)
                this.tenToggle = true
            }
            if (!this.chessConsole.isPlayerWhite() && serverClockBlack < 11 && serverClockBlack > 0) {
                this.chessConsole.messageBroker.publish(consoleMessageTopics.tenSecondsLeft)
                this.tenToggle = true
            }
        }
    }

}
